import { CreatorIcon, CreatorService } from '../../PastMeetings/CreatorIcon'
import { creatorServiceToNameMap } from './constants'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'

export interface CreatorType {
  creator: CreatorService
}

export const CreatorType = ({ creator }: CreatorType) => {
  return (
    <div className='d-flex gap-2 align-items-center'>
      <CreatorIcon creator={creator} displayTooltip={false} />
      <Tooltip title='Meeting source' placement='bottom'>
        {creatorServiceToNameMap[creator]}
      </Tooltip>
    </div>
  )
}
